import React from "react";
import "./Section.styles.scss";

const Section = ({ children, title, id }) => {
	return (
		<section id={id} className="section is-medium">
			<div className="container">
				<h1 className="title is-size-1">{title}</h1>
				<div className="tile is-ancestor section-box">{children}</div>
			</div>
		</section>
	);
};

export default Section;
